import React from 'react';
import { HashRouter, Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import CssBaseline from '@material-ui/core/CssBaseline'
import IconButton from '@material-ui/core/IconButton'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Menu } from '@material-ui/icons'
import MyDrawer from './myDrawer'
import { routes } from '../../config/routes'
import './layout.css'
import './colores.css'

const drawerWidth = 300;

const styles = theme => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 25,
    padding: '24px'
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
  },
});

class Layout extends React.Component {

  render() {
    const { classes } = this.props;
    return (
      <HashRouter instalacion={this.props.instalacion}>
        <div className={classNames(classes.root, process.env.REACT_APP_ENVIROMENT === 'testing' ? 'ecommerce-test' : '')} id={'ecommerce'}>
          <CssBaseline />
          {this.props.header.show &&
            <AppBar
              position="fixed"
              className={classNames(classes.appBar, {
                [classes.appBarShift]: this.props.drawerOpen,
              })}
            >
              <Toolbar disableGutters={!this.props.drawerOpen} className='toolbar'>
                <IconButton
                  color="inherit"
                  aria-label="Open drawer"
                  onClick={this.props.handleDrawerOpen}
                  className={classNames(classes.menuButton, 'drawerButton', {
                    [classes.hide]: this.props.drawerOpen,
                  })}
                >
                  <Menu />
                </IconButton>
                {/* logo de DISTRICT */}
                {
                  process.env.REACT_APP_ENVIROMENT === 'testing' ?
                    <div className='labelTest'>TEST</div>
                    :
                    (!this.props.drawerOpen &&
                      <div className='logoContainer'>
                        <Link to='/'>
                          <img src={this.props.instalacion.logoDrawer} alt="" />
                        </Link>
                      </div>)
                }

                {/* información del usuario logeado */}
                {/* DESCOMENTAR PARA VER ESTA FUNCIONALIDAD <LoggedUser />*/}
                <div>
                  <label class="text-right usuarioLogueado">
                    {this.props.usuario && this.props.usuario.nombreUsuario}
                  </label>
                  <label class="text-right sucursalSeleccionada" onClick={() => { window.location.hash = '/SeleccionSucursal' }}>
                    {this.props.sucursal && this.props.sucursal?.nombre?.toUpperCase()}
                  </label>
                </div>
              </Toolbar>
            </AppBar>}

          {/* menú lateral */}
          {this.props.header.show &&
            <MyDrawer
              usuario={this.props.usuario}
              instalacion={this.props.instalacion}
              handleCerrarSession={this.props.handleCerrarSession}
              drawerOpen={this.props.drawerOpen}
              handleDrawerClose={this.props.handleDrawerClose}
              isPermanent
            />}

          {/* sección principal */}
          <main className={classes.content}>
            <div className={classes.toolbar} />

            {routes()}

          </main>

          {/* LOADER */}
          {this.props.loading.show &&
            <div id='loader'>
              <div>
                <div className='loaderContainer'>
                  <CircularProgress />
                  <div className='mensaje'>{this.props.loading.message || 'Espere por favor'}</div>
                </div>
              </div>
            </div>}

        </div>
      </HashRouter>
    );
  }
}

Layout.propTypes = {
  drawerOpen: PropTypes.bool.isRequired,
  handleDrawerOpen: PropTypes.func.isRequired,
  handleDrawerClose: PropTypes.func.isRequired,
  handleCerrarSession: PropTypes.func.isRequired,
  loading: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  usuario: PropTypes.object.isRequired,
  header: PropTypes.object.isRequired,
  sucursal: PropTypes.object.isRequired
}

export default withStyles(styles, { withTheme: true })(Layout);